// extracted by mini-css-extract-plugin
module.exports = {"container":"FullWidthContent-module--container--2tHeJ","insideContainer":"FullWidthContent-module--insideContainer--2yOi2"};